import { render, staticRenderFns } from "./fenpei.vue?vue&type=template&id=055f79ce&scoped=true"
import script from "./fenpei.vue?vue&type=script&lang=js"
export * from "./fenpei.vue?vue&type=script&lang=js"
import style0 from "./fenpei.vue?vue&type=style&index=0&id=055f79ce&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055f79ce",
  null
  
)

export default component.exports